/**
 * P8-2c: JS 側インライン style で使う motion 定数の一元管理。
 *
 * CSS 側の正本は styles/shell-tokens.css の easing トークン群。動的な transition 文字列を
 * JS で合成する箇所（例: 立ち絵/カメラの focus 演出）は CSS 変数を参照できないため、
 * ここに同値の文字列定数を置いて重複リテラルの散在を防ぐ。
 * 値を変えるときは shell-tokens.css 側のトークンと必ず同時に更新すること。
 */

/** 弾む強調（backOut）。= --shell-ease-emphasis / --mg-ease-emphasis（foundation/tokens/motion.css）と同値 */
export const EASE_EMPHASIS = 'cubic-bezier(0.34, 1.56, 0.64, 1)';

/** ズームアウトの戻り（backIn）。= --shell-ease-back-in（shell-tokens.css）と同値 */
export const EASE_BACK_IN = 'cubic-bezier(0.36, 0, 0.66, -0.56)';
